import { Button } from "antd";
import React from "react";
import { AdStatus } from "../../../../../models";
import { getIconUrl } from "../../../../../services/asset";
import { PromotedButton } from "./PromotedButton";
import { Button as ButtonComponent } from "../../../../../components/Button/Button";
import styles from "../adCard.scss"

export const PromotionButton = ({ ad, adActions }) => {
  const shouldShowSearchPagePosition = ad.searchPagePosition != null && ad.searchPagePosition > 0

  return (
    <React.Fragment>

      {ad.isPromoted ? (
        <PromotedButton ad={ad} adActions={adActions} shouldShowSearchPagePosition={shouldShowSearchPagePosition} />
      ) : ad.awaitingPayment ? (
        <Button
          onClick={adActions.onAwaitingPayment}
          disabled={ad.status !== AdStatus.active}
          className={styles.button}
          style={{ background: "#f5f5f5", color: "#c6c6cd" }}
        >
          <div>
            <img
              src={getIconUrl("promote-small-gray.svg")}
            />
            Oglas čeka plaćanje
          </div>
          {shouldShowSearchPagePosition && (
            <span className={styles.subText}>
              {`Trenutno na ${ad.searchPagePosition}. stranici kategorije`}
            </span>
          )}
        </Button>
      ) : (
        <ButtonComponent
          type="primary"
          onClick={ad.hasFreePromotion ? null : adActions.onPromote}
          disabled={ad.status !== AdStatus.active}
          className={styles.button}
        >
          <div>
            <img
              src={ad.status !== AdStatus.active ?
                getIconUrl("promote-small-gray.svg") :
                getIconUrl("promote-small-white.svg")}
            />
            Istakni oglas
          </div>
          {shouldShowSearchPagePosition && (
            <span className={styles.subText}>
              {`Trenutno na ${ad.searchPagePosition}. stranici kategorije`}
            </span>
          )}
        </ButtonComponent>
      )}
    </React.Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/AdCard/AdCardActions/PromotionButton.tsx